import { ImageSelectorProps } from "@bluframe/mightychroma-mightytool-frontend-types"
import { fn } from "storybook/test"

const imageSelector: ImageSelectorProps = {
  images: [
    {
      originalUrl: "https://www.avnirvana.com/attachments/front-jpg.73800/"
    },
    {
      contentId: 1,
      filename: "bringing-out-the-dead-4k-uhd-cover.png",
      originalUrl:
        "https://images.static-bluray.com/movies/covers/364668_front.jpg?t=1725645482"
    },
    {
      id: "ae162b0c-4f2e-4a3d-8f1b-5a7c6d9e0b8f",
      filename: "bringing-out-the-dead-uhd.jpg",
      originalUrl:
        "https://blurayauthority.com/images/cover_art/bringingoutthedeaduhd.jpg;%20?%3E"
    },
    {
      contentId: 2,
      filename:
        "bringing-out-the-dead-scorsese-4kuhd-paramount-presents-cover.png",
      originalUrl:
        "http://cdn2.highdefdigest.com/media/2024/06/24/660/127407/bringing-out-the-dead-scorsese-4kuhd-paramount-presents-cover.png"
    },
    {
      id: "a4f3b0a2-5d1e-4f8b-9c7d-5a7c6d9e0b8a",
      filename: "bringing-out-the-dead-uhd-cover.jpg",
      originalUrl: "https://i.ebayimg.com/images/g/kPwAAOSwa2xnUX1o/s-l400.png"
    }
  ],
  modal: {
    isOpen: false,
    onClose: fn()
  },
  onConfirm: fn(),
  onSelectClick: fn()
}

export const imageSelectorAndIdentifiers = imageSelector.images!.map(
  (item, index) => ({
    ...item,
    identifier: `image-${index}`
  })
)

export default imageSelector
